module.exports = __webpack_public_path__ + "img/quad-heating-lg.a735e41f.svg";